export const predictionLineTypeAdditional = 'Additional Lower Data';
